export default "__VITE_ASSET__DVjm2g_x__"